import React from "react";
import Loader from "../../../../general/boxLoader";
import PatientVisitCardsItem from "./patientVisitCards_Item";
import EmptyBox from "../../../../general/emptyBox";
import { Accordion } from "react-bootstrap";
import ShowPatientSakhadVisitModal from "../showPatientSakhadVisitModal";

type PatientVisitsCardsProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean;
};

const PatientVisitCards = ({
  dataList,
  dataListTitles,
  isRequesting,
}: PatientVisitsCardsProps) => {
  const _dataList =
    dataList?.data &&
    dataList?.data.length > 0 &&
    dataList?.data.map((item: any, i: number) => {
      return (
        <PatientVisitCardsItem
          item={item}
          dataListTitles={dataListTitles}
          key={i}
        />
      );
    });
  return (
    <div>
      {isRequesting ? (
        <Loader />
      ) : _dataList ? (
        _dataList
      ) : (
        <EmptyBox content={""} className={""} children={""} />
      )}
      <ShowPatientSakhadVisitModal />;
    </div>
  );
};

export default PatientVisitCards;
